module.exports = __webpack_public_path__ + "img/block-shooter.a761acc9.png";